import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckmarkCircle16Filled, Circle16Regular } from '@fluentui/react-icons';

interface VisitConceptStatusIconProps {
  realized: boolean;
}

/** Estado del concepto: tilde verde si está realizado, círculo vacío si no. Siempre con texto accesible. */
const VisitConceptStatusIcon: React.FC<VisitConceptStatusIconProps> = ({ realized }) => {
  const { t } = useTranslation();
  const label = realized ? t('visitConcepts.tree.realized') : t('visitConcepts.tree.notRealized');
  return (
    <span
      className={`vct-status ${realized ? 'vct-status--realized' : 'vct-status--pending'}`}
      role="img"
      aria-label={label}
      title={label}
      data-testid={realized ? 'vct-status-realized' : 'vct-status-pending'}
    >
      {realized ? <CheckmarkCircle16Filled /> : <Circle16Regular />}
    </span>
  );
};

export default VisitConceptStatusIcon;
